import Vue from 'vue';
import VueRouter from 'vue-router';

import layout from "@/layout/auto.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {

    return originalPush.call(this, location).catch(err => err)

}



const routes = [
    {
        path: '/',
        redirect: '/Home/index'
    },
    {
        path: '/',
        name: "index",
        redirect: '/Home',
        component: () => import('@/layout/admin.vue'),
        meta: { title: 'admin' },
        children:[
            //首页******************************************************
            {
                path: '/Home',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "首页",
                        component: () => import('@/views/Home/index.vue'),
                        meta: { activeMenu: '/Home/index',index:0  },
                    }
                ]
            },
            //产品中心******************************************************
            {
                path: '/Products',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "产品中心",
                        component: () => import('@/views/Products/index.vue'),
                        meta: { activeMenu: '/Products/index',index:1  },
                    }
                ]
            },
            //解决方案******************************************************
            {
                path: '/Algorithm',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "解决方案",
                        component: () => import('@/views/Algorithm/index.vue'),
                        meta: { activeMenu: '/Algorithm/index',index:2  },
                    }
                ]
            },
            //关于我们******************************************************
            {
                path: '/About',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "关于我们",
                        component: () => import('@/views/About/index.vue'),
                        meta: { activeMenu: '/About/index',index:4  },
                    }
                ]
            },
            //产品详情页******************************************************
            {
                path: '/DetailsPages',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "产品中心",
                        component: () => import('@/views/DetailsPages/index.vue'),
                        meta: { activeMenu: '/DetailsPages/index'   },
                    }
                ]
            },
            //公司动态******************************************************
            {
                path: '/CompanyNews',
                component: layout,
                children: [
                    {
                        path: 'index',
                        name: "产品中心",
                        component: () => import('@/views/CompanyNews/index.vue'),
                        meta: { activeMenu: '/CompanyNews/index' ,index:3 },
                    }
                ]
            },
        ]
    },
]
export default new VueRouter({
    base: process.env.BASE_URL,
    routes
})
